import { render, staticRenderFns } from "./staffList.vue?vue&type=template&id=01f60a06&scoped=true"
import script from "./staffList.vue?vue&type=script&lang=js"
export * from "./staffList.vue?vue&type=script&lang=js"
import style0 from "./staffList.vue?vue&type=style&index=0&id=01f60a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f60a06",
  null
  
)

export default component.exports